import RouteManager from "./routeManager/RouteManager";

function App() {
  return (
    <div>
      <RouteManager />
    </div>
  );
}

export default App;
